import { Root } from "hast";

// TODO: find a better way of avoiding hydration errors
// this one seem's not to be the best one
export default function rehypeRemoveNewlines() {
    return (tree: Root) => {
        for (let i = 0; i < tree.children.length; ) {
            const node = tree.children[i];
            if (node.type === "text" && node.value.match(/^\n+$/)) {
                tree.children.splice(i, 1);
            } else {
                i++;
            }
        }
    };
}
